import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Field')
export class Field {
  @JsonProperty('code', String, true) code: string = undefined;
  @JsonProperty('label', String, true) label: string = undefined;
}
